import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet";
import config from "../coreFIles/config";
import toast, { Toaster } from 'react-hot-toast';
import Header from '../directives/header'
import Leftnav from '../directives/leftSidebar'
import Rightnav from '../directives/rightSidebar'
import Footer from '../directives/footer'
import Cookies from 'js-cookie'
import ReCAPTCHA from 'react-google-recaptcha';
import { getadDataAction, getadImgesAction, getRelatedAdsAction, getMemberFavouriteAdsAction, SaveFavouriteAdsAction, reportthisadAction, sharewithfriendAction, replyToclassifiedAction, getdomainContentAction, getDoaminStyleAction, memberloginwithfacebookAction, categoryadsAction, getHozBannerForCategoryAction, logBannerClickAction } from '../Action/action';
import { getDomainData, getDomainStyles } from '../utils/staticDomainData';
import { getDomainIdWithData } from '../utils/domainHelpers';
import moment from 'moment';
import FacebookLogin from '@greatsumini/react-facebook-login';

const getLoginData = () => {
	try {
		const cookieData = Cookies.get('loginSuccessMember');
		return cookieData ? JSON.parse(cookieData) : [];
	} catch (error) {
		console.error('Error parsing loginSuccessMember cookie:', error);
		return [];
	}
};

const loginData = getLoginData();
const Domainid = getDomainIdWithData();
const ageVerified = (!Cookies.get('ageVerified')) ? false : Cookies.get('ageVerified');

const Addetails = () => {
	const navigate = useNavigate();
	const { id } = useParams();
	const { any } = useParams();
	const { urldomain } = useParams()
	
	// Style state for reactive styling - use static data directly
	const [Style, setStyle] = useState([]);
	
	useEffect(() => {
		const updateStyles = () => {
			try {
				const domainId = Domainid?.domain_id || 0;
				const domainStyles = getDomainStyles(domainId);
				setStyle(domainStyles || []);
			} catch (error) {
				console.error('Error getting domain styles:', error);
				setStyle([]);
			}
		};
		
		updateStyles();
		// Check for domain changes every 500ms
		const interval = setInterval(updateStyles, 500);
		return () => clearInterval(interval);
	}, []);
	
	// Style values
	const getStyleValue = (key) => {
		if (Style && Array.isArray(Style) && Style.length > 0 && Style[0] && Style[0][key]) {
			return `#${Style[0][key]}`;
		}
		return '';
	};
	const timeColor = getStyleValue('time_color');
	const headerButtonColor = getStyleValue('header_buttoncolor');
	const headerMenuColor = getStyleValue('header_menu');
	const headerMenuHoverColor = getStyleValue('header_menu_hover');
	const header_search_text = getStyleValue('header_search_text');
	const [adData, setadData] = useState({});
	const [spinloader, setspinloader] = useState(0);
	const [adImges, setadImges] = useState({});
	const [relatedAds, setRelatedAds] = useState({});
	const [adUrl, setAdUrl] = useState('');
	const [catUrl, setCatUrl] = useState('');
	const [getfavAds, setgetfavAds] = useState([])
	const [resume, setresume] = useState(0)
	const [replyto, setreplyto] = useState(0)
	const [prevAd, setPrevAd] = useState(null)
	const [nextAd, setNextAd] = useState(null)
	const [topBanner, setTopBanner] = useState(null)
	// for report page
	const [showreport, setshowreport] = useState(0)
	const [validationError, setvalidationError] = useState({});
	const recaptchaRef = useRef(null);
	const lightGalleryRef = useRef(null);


	const [form, setForm] = useState({
		id: "6",
		domain_id: Domainid && Domainid.domain_id ? Domainid.domain_id : "0",
		name: (loginData && Array.isArray(loginData) && loginData.length > 0 ? loginData[0] : loginData)?.fname || "",
		title: (Domainid && Domainid.data && Array.isArray(Domainid.data) && Domainid.data.length > 0) ? Domainid.data[0].title : "Bondi classifieds",
		email: (loginData && Array.isArray(loginData) && loginData.length > 0 ? loginData[0] : loginData)?.email || "",
		msg: '',
		captchaValue: "",

	});
	const [replyform, setsetreplyForm] = useState({
		id: "5",
		domain_id: Domainid && Domainid.domain_id ? Domainid.domain_id : "0",
		name: (loginData && Array.isArray(loginData) && loginData.length > 0 ? loginData[0] : loginData)?.fname || "",
		title: any,
		email: (loginData && Array.isArray(loginData) && loginData.length > 0 ? loginData[0] : loginData)?.email || "",
		msg: '',
		captchaValue: "",
		images: {},
		member_id: "",
	});

	const [emailform, setemailform] = useState({
		id: "10",
		domain_id: Domainid && Domainid.domain_id ? Domainid.domain_id : "0",
		name: (loginData && Array.isArray(loginData) && loginData.length > 0 ? loginData[0] : loginData)?.fname || "",
		title: (Domainid && Domainid.data && Array.isArray(Domainid.data) && Domainid.data.length > 0) ? Domainid.data[0].title : "Bondi classifieds",
		email: (loginData && Array.isArray(loginData) && loginData.length > 0 ? loginData[0] : loginData)?.email || "",
		femail: "",
		msg: '',
		captchaValue: ""
	});

	useEffect(() => {
		if (urldomain) {
			getDomainContentApi(urldomain);
			getadData();
		} else {
			getadData();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		getadData();
		getadImges();
		const userData = (loginData && Array.isArray(loginData) && loginData.length > 0 ? loginData[0] : loginData);
		if (!userData || (Array.isArray(loginData) && loginData.length === 0)) {
			return
		}
		else {
			GetFavoriteAds()
		}

	}, [])

	// Add custom styles for lightgallery
	useEffect(() => {
		const styleId = 'lightgallery-custom-styles';
		if (!document.getElementById(styleId)) {
			const style = document.createElement('style');
			style.id = styleId;
			style.textContent = `
				/* Semi-transparent dark background */
				.lg-backdrop {
					background-color: rgba(0, 0, 0, 0.85) !important;
					opacity: 1 !important;
				}
				
				/* Lightbox container - centered */
				.lg-outer {
					display: flex !important;
					align-items: center !important;
					justify-content: center !important;
				}
				
				/* Content wrapper - properly sized and centered */
				.lg-outer .lg-content {
					position: absolute !important;
					top: 50% !important;
					left: 50% !important;
					transform: translate(-50%, -50%) !important;
					max-width: 95vw !important;
					max-height: 95vh !important;
					width: auto !important;
					height: auto !important;
					margin: 0 !important;
					right: auto !important;
					bottom: auto !important;
				}
				
				/* Image container */
				.lg-outer .lg-inner {
					position: relative !important;
					width: 100% !important;
					height: 100% !important;
					display: flex !important;
					align-items: center !important;
					justify-content: center !important;
				}
				
				/* Image wrapper - centered */
				.lg-outer .lg-item {
					display: flex !important;
					align-items: center !important;
					justify-content: center !important;
				}
				
				.lg-outer .lg-img-wrap {
					display: flex !important;
					align-items: center !important;
					justify-content: center !important;
					max-width: 95vw !important;
					max-height: 90vh !important;
					width: auto !important;
					height: auto !important;
					margin: 0 auto !important;
				}
				
				/* Image itself - responsive sizing */
				.lg-outer .lg-object {
					max-width: 95vw !important;
					max-height: 90vh !important;
					width: auto !important;
					height: auto !important;
					object-fit: contain !important;
					margin: 0 auto !important;
					display: block !important;
				}
				
				/* Toolbar styling - better visibility */
				.lg-toolbar {
					background: rgba(0, 0, 0, 0.7) !important;
					border-radius: 8px !important;
					padding: 8px 12px !important;
					backdrop-filter: blur(5px) !important;
				}
				
				.lg-toolbar .lg-icon {
					color: #fff !important;
					opacity: 0.9 !important;
				}
				
				.lg-toolbar .lg-icon:hover {
					opacity: 1 !important;
				}
				
				/* Navigation buttons - better styling and positioning */
				.lg-next, .lg-prev {
					background: rgba(0, 0, 0, 0.7) !important;
					border-radius: 50% !important;
					width: 50px !important;
					height: 50px !important;
					display: flex !important;
					align-items: center !important;
					justify-content: center !important;
					opacity: 0.9 !important;
					backdrop-filter: blur(5px) !important;
					transition: all 0.3s ease !important;
					position: absolute !important;
					z-index: 1060 !important;
					cursor: pointer !important;
				}
				
				.lg-prev {
					left: 20px !important;
					top: 50% !important;
					transform: translateY(-50%) !important;
				}
				
				.lg-next {
					right: 20px !important;
					top: 50% !important;
					transform: translateY(-50%) !important;
				}
				
				.lg-next:hover, .lg-prev:hover {
					opacity: 1 !important;
					background: rgba(0, 0, 0, 0.9) !important;
					transform: translateY(-50%) scale(1.1) !important;
				}
				
				.lg-prev:hover {
					transform: translateY(-50%) scale(1.1) !important;
				}
				
				/* Arrow icons */
				.lg-next:before, .lg-prev:after {
					color: #fff !important;
					font-size: 20px !important;
				}
				
				/* Thumbnail container styling */
				.lg-thumb-outer {
					background: rgba(0, 0, 0, 0.8) !important;
					padding: 15px 0 !important;
					bottom: 0 !important;
					width: 100% !important;
					position: fixed !important;
					z-index: 1055 !important;
					backdrop-filter: blur(10px) !important;
				}
				
				.lg-thumb {
					display: flex !important;
					justify-content: center !important;
					align-items: center !important;
					gap: 10px !important;
					padding: 0 20px !important;
					overflow-x: auto !important;
					overflow-y: hidden !important;
					-webkit-overflow-scrolling: touch !important;
					scrollbar-width: none !important;
					-ms-overflow-style: none !important;
				}
				
				.lg-thumb::-webkit-scrollbar {
					display: none !important;
					width: 0 !important;
					height: 0 !important;
				}
				
				.lg-thumb-item {
					flex-shrink: 0 !important;
					width: 80px !important;
					height: 80px !important;
					margin: 0 5px !important;
					cursor: pointer !important;
					opacity: 0.6 !important;
					transition: all 0.3s ease !important;
					border: 2px solid transparent !important;
					border-radius: 4px !important;
					overflow: hidden !important;
					display: block !important;
					position: relative !important;
				}
				
				.lg-thumb-item.active {
					opacity: 1 !important;
					border-color: #fff !important;
					transform: scale(1.1) !important;
				}
				
				.lg-thumb-item:hover {
					opacity: 0.9 !important;
					transform: scale(1.05) !important;
				}
				
				.lg-thumb-item.active:hover {
					transform: scale(1.15) !important;
				}
				
				.lg-thumb-item img {
					width: 100% !important;
					height: 100% !important;
					object-fit: cover !important;
					display: block !important;
				}
				
				/* Ensure thumbnails are visible */
				.lg-components {
					display: block !important;
				}
				
				/* Fix for thumbnail plugin */
				.lg-outer.lg-thumb-open .lg-thumb-outer {
					display: block !important;
				}
				
				/* Counter styling */
				.lg-counter {
					color: #fff !important;
					opacity: 0.9 !important;
				}
				
				/* Ensure proper z-index */
				.lg-outer {
					z-index: 1050 !important;
				}
				
				.lg-backdrop {
					z-index: 1040 !important;
				}
			`;
			document.head.appendChild(style);
		}

		return () => {
			const styleElement = document.getElementById(styleId);
			if (styleElement) {
				styleElement.remove();
			}
		};
	}, []);

	// Initialize lightgallery when images are loaded
	useEffect(() => {
		if (adImges.length > 0) {
			// Wait for lightgallery to be available
			const initLightGallery = () => {
				// Check if lightgallery is available
				const lightGalleryFn = window.lightGallery;
				if (!lightGalleryFn) {
					// Retry after a short delay if library not loaded yet (max 10 attempts)
					if (initLightGallery.retries < 10) {
						initLightGallery.retries = (initLightGallery.retries || 0) + 1;
						setTimeout(initLightGallery, 200);
					} else {
						console.error('lightGallery library not found after multiple attempts');
					}
					return;
				}

				// Destroy existing instance if any
				if (lightGalleryRef.current) {
					try {
						lightGalleryRef.current.destroy();
					} catch (e) {
						// Ignore destroy errors
					}
					lightGalleryRef.current = null;
				}
				
				// Initialize lightgallery
				const galleryElement = document.getElementById('lightgallery');
				if (galleryElement) {
					try {
						// Get plugins if available
						const plugins = [];
						if (typeof window.lgZoom !== 'undefined') plugins.push(window.lgZoom);
						if (typeof window.lgThumbnail !== 'undefined') {
							plugins.push(window.lgThumbnail);
						}
						
						const options = {
							speed: 500,
							mode: 'lg-fade',
							thumbnail: typeof window.lgThumbnail !== 'undefined',
							showThumbByDefault: true,
							animateThumb: true,
							currentPagerPosition: 'middle',
							thumbWidth: 80,
							thumbHeight: 80,
							thumbMargin: 5,
						};
						
						if (plugins.length > 0) {
							options.plugins = plugins;
						}
						
						lightGalleryRef.current = lightGalleryFn(galleryElement, options);
						console.log('Lightgallery initialized successfully');
					} catch (error) {
						console.error('Error initializing lightgallery:', error);
					}
				} else {
					console.error('Gallery element not found');
				}
			};

			initLightGallery.retries = 0;
			// Small delay to ensure DOM is updated
			setTimeout(initLightGallery, 300);
		}

		// Cleanup on unmount
		return () => {
			if (lightGalleryRef.current) {
				try {
					lightGalleryRef.current.destroy();
				} catch (error) {
					// Ignore destroy errors
				}
				lightGalleryRef.current = null;
			}
		};
	}, [adImges])

	// for getting your favourites ads
	const GetFavoriteAds = async () => {
		try {
			if (!Cookies.get('loginSuccessMember')) {
				return null
			} else {
				const res = await getMemberFavouriteAdsAction({ memberid: loginData?.id });
				if (res.success) {
					const adId = res.data;
					setgetfavAds(adId)
				} else {
					toast.error(`Failed to fetch favorite ads: ${res.error}`);
				}
			}
		} catch (error) {

			toast.error(`An error occurred while fetching favorite ads: ${error}`);
		}
	};

	const handleOver18 = () => {
		Cookies.set('ageVerified', 'true', { expires: 0.0208333 });
		window.location.reload();
	};

	const handleUnder18 = () => {
		var pagenewUrl = config.baseUrl;
		window.location.href = `${pagenewUrl}`;
	};
	// favouriate ads
	const handleFavorite = async (adId) => {
		if (!Cookies.get('loginSuccessMember')) {
			toast.error('Please login first.');
			return null;
		}
		try {
			const userData = (loginData && Array.isArray(loginData) && loginData.length > 0 ? loginData[0] : loginData);
			let res = await SaveFavouriteAdsAction({
				memberid: userData?.id || "",
				adid: adId
			});
			if (res.success) {
				toast.success(res.msg);
				GetFavoriteAds()
			}
			else {
				toast.error(res.msg);
				GetFavoriteAds()
			}


		} catch (error) {
			console.error('Error saving favorite ad:', error);
			toast.error('Failed to save ad to favorites');
		}


	};
    const getadData = async () => {
		setspinloader(1)
		let res = await getadDataAction({ id: id, any: any });
		if (res.success) {
			setadData(res.data);
			setspinloader(0)
			getRelatedAds(res.data.category_id, id);
            loadPrevNext(res.data.category_id, res.data.id)
		}
		else {
			window.location.href = `${config.baseUrl}`
		}

	};

	
	const loadPrevNext = async (categoryId, currentAdId) => {
		try {
			let res = await categoryadsAction({ catId: categoryId, domain_id: Domainid?.domain_id });
			if (res.success && Array.isArray(res.data)) {
				const list = res.data;
				const currentIndex = list.findIndex(row => String(row.id) === String(currentAdId));
				if (currentIndex !== -1) {
					setPrevAd(currentIndex > 0 ? list[currentIndex - 1] : null);
					setNextAd(currentIndex < list.length - 1 ? list[currentIndex + 1] : null);
				} else {
					setPrevAd(null);
					setNextAd(null);
				}
			} else {
				setPrevAd(null);
				setNextAd(null);
			}
		} catch (e) {
			setPrevAd(null);
			setNextAd(null);
		}
	}
	const getadImges = async () => {
		let res = await getadImgesAction({ id: id });
		if (res.success) {
			setadImges(res.data);
		} else {
			setadImges('');
		}
	};
	// related ads
	const getRelatedAds = async (id, category_id) => {
		var currentDate = new Date();
		currentDate = moment(currentDate).subtract(2, "year");
		currentDate = moment(currentDate).format('YYYY-MM-DD');

		let res = await getRelatedAdsAction({ id, category_id, date: currentDate });

		if (res.success) {
			setRelatedAds(res.data);
		} else {
			setRelatedAds('');
		}


	};
	// function to redirect to ad url on click ad title
	const handleAdUrl = (row) => {
		var pagenewUrl = '';
		pagenewUrl = config.baseUrl + 'ad/' + row.id + '/' + row.parent_cat.replace(/ /g, "-").replace(/'/g, "").replace(/&/g, "and").replace(/[^A-Za-z0-9\-\']/g, '').toLowerCase() + '-' + row.cat_name.replace(/ /g, "-").replace(/'/g, "").replace(/&/g, "and").replace(/[^A-Za-z0-9\-\']/g, '').toLowerCase() + '-' + row.title.replace(/ /g, "-").replace(/'/g, "").replace(/&/g, "and").replace(/[^A-Za-z0-9\-\']/g, '').toLowerCase();
		window.location.href = `${pagenewUrl}`;

	};
	// function to redirect to category ads page on click category title
	const handleCatUrl = (row) => {
		var pagenewUrl = '';
		pagenewUrl = config.baseUrl + 'cat/' + row.category_id + '/' + row.parent_cat.replace(/ /g, "-").replace(/'/g, "").replace(/&/g, "and").replace(/[^A-Za-z0-9\-\']/g, '').toLowerCase() + '-' + row.cat_name.replace(/ /g, "-").replace(/'/g, "").replace(/&/g, "and").replace(/[^A-Za-z0-9\-\']/g, '').toLowerCase();
		window.location.href = `${pagenewUrl}`;
	};
	// function to create ad url on hover ad title
	const getAdUrl = (row) => {
		var pagenewUrl = '';
		pagenewUrl = config.baseUrl + 'ad/' + row.id + '/' + row.parent_cat.replace(/ /g, "-").replace(/'/g, "").replace(/&/g, "and").replace(/[^A-Za-z0-9\-\']/g, '').toLowerCase() + '-' + row.cat_name.replace(/ /g, "-").replace(/'/g, "").replace(/&/g, "and").replace(/[^A-Za-z0-9\-\']/g, '').toLowerCase() + '-' + row.title.replace(/ /g, "-").replace(/'/g, "").replace(/&/g, "and").replace(/[^A-Za-z0-9\-\']/g, '').toLowerCase();
		setAdUrl(pagenewUrl);


	};

	// function to create category url on hover ad title
	const getCatUrl = (row) => {
		var pagenewUrl = '';
		pagenewUrl = config.baseUrl + 'cat/' + row.category_id + '/' + row.parent_cat.replace(/ /g, "-").replace(/'/g, "").replace(/&/g, "and").replace(/[^A-Za-z0-9\-\']/g, '').toLowerCase() + '-' + row.cat_name.replace(/ /g, "-").replace(/'/g, "").replace(/&/g, "and").replace(/[^A-Za-z0-9\-\']/g, '').toLowerCase();

		setCatUrl(pagenewUrl);
	};
	const handleadUrl = (row) => {
		const pagenewUrl = `${config.baseUrl}cat/${row.category_id}/${row.parent_cat.replace(/ /g, "-").replace(/'/g, "").replace(/&/g, "and").replace(/[^A-Za-z0-9\-\']/g, '').toLowerCase()}-${row.cat_name.replace(/ /g, "-").replace(/'/g, "").replace(/&/g, "and").replace(/[^A-Za-z0-9\-\']/g, '').toLowerCase()}?title=${encodeURIComponent(row.title)}&id=${row.id}`;

		window.location.href = pagenewUrl;
	};
    const handlePrev = () => {
        if (!prevAd) return;
        handleAdUrl(prevAd);
    };

    const handleNext = () => {
        if (!nextAd) return;
        handleAdUrl(nextAd);
    };
	// Ad report form
	const inputHandler = (e) => {
		const { name, value } = e.target;
		setForm((prev) => ({
			...prev,
			[name]: value,
		}));
	};
	const onCaptchaChange = (value) => {
		setForm((prev) => ({ ...prev, captchaValue: value }));
	};
	const ShowReportFrom = (adData) => {
		if (!loginData) {
			window.location.href = `${config.baseUrl}`
		} else {
			setshowreport(1)
			var pagenewUrl = '';
			pagenewUrl = config.baseUrl + 'ad/' + adData.id + '/' + adData.parent_cat.replace(/ /g, "-").replace(/'/g, "").replace(/&/g, "and").replace(/[^A-Za-z0-9\-\']/g, '').toLowerCase() + '-' + adData.cat_name.replace(/ /g, "-").replace(/'/g, "").replace(/&/g, "and").replace(/[^A-Za-z0-9\-\']/g, '').toLowerCase() + '-' + adData.title.replace(/ /g, "-").replace(/'/g, "").replace(/&/g, "and").replace(/[^A-Za-z0-9\-\']/g, '').toLowerCase();

			setAdUrl(pagenewUrl);
			window.scrollTo(1, 1)
		}
	}
	function validate() {
		let nameError = "";
		let emailError = "";
		let msgError = "";
		let captchaValueError = "";
		if (form.name === '') nameError = "Name is required.";

		const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		if (form.email === '') {
			emailError = "Email is required.";
		} else if (!emailRegex.test(form.email)) {
			emailError = "Please enter a valid email address.";
		}
		if (form.msg === '') msgError = "Message is required.";
		if (form.captchaValue === '') captchaValueError = "Captcha is required.";
		if (nameError || emailError || msgError || captchaValueError) {
			setvalidationError({
				nameError, emailError, msgError, captchaValueError
			});
			return false;
		} else {
			setvalidationError({
				nameError, emailError, msgError, captchaValueError
			});
			return true;
		}

	}
	const SubmitForm = async (e) => {
		e.preventDefault();
		const isValid = validate();
		if (!isValid) return;

		setspinloader(1);
		let res = await reportthisadAction({
			...form, adid: id,
			title: adData?.title,
			url: `https://bondi-front.lyonsdemo.in${adUrl}`

		});
		if (res.success) {
			toast.success(res.msg);
			setTimeout(() => {
				window.location.reload()
			}, 1200)

		} else {
			toast.error(res.msg);
		}
		setspinloader(0);
		setTimeout(() => {
			window.location.href = `${config.baseUrl}`
		}, 3000);
	};

	// email friend form
	const emailinputHandler = (e) => {
		const { name, value } = e.target;
		setemailform((prev) => ({
			...prev,
			[name]: value,


		}));
	};
	function emailFormvalidate() {
		let nameError = ""
		let femailError = "";
		let emailError = "";
		let msgError = "";
		let captchaValueError = "";
		const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		if (emailform.name === '') nameError = "Name is required"

		if (emailform.femail === '') {
			femailError = "Email is required.";
		} else if (!emailRegex.test(emailform.femail)) {
			femailError = "Please enter a valid email address.";
		}

		if (emailform.email === '') {
			emailError = "Email is required.";
		} else if (!emailRegex.test(emailform.email)) {
			emailError = "Please enter a valid email address.";
		}
		if (emailform.msg === '') msgError = "Message is required.";
		if (emailform.captchaValue === '') captchaValueError = "Captcha is required.";
		if (nameError || femailError || emailError || msgError || captchaValueError) {
			setvalidationError({
				nameError, femailError, emailError, msgError, captchaValueError
			});
			return false;
		} else {
			setvalidationError({
				nameError, femailError, emailError, msgError, captchaValueError
			});
			return true;
		}

	}
	const ShowFriendFrom = (adData) => {
		if (!loginData) {
			window.location.href = `${config.baseUrl}`
		}
		else {
			setshowreport(2)
			var pagenewUrl = '';
			pagenewUrl = config.baseUrl + 'ad/' + adData.id + '/' + adData.parent_cat.replace(/ /g, "-").replace(/'/g, "").replace(/&/g, "and").replace(/[^A-Za-z0-9\-\']/g, '').toLowerCase() + '-' + adData.cat_name.replace(/ /g, "-").replace(/'/g, "").replace(/&/g, "and").replace(/[^A-Za-z0-9\-\']/g, '').toLowerCase() + '-' + adData.title.replace(/ /g, "-").replace(/'/g, "").replace(/&/g, "and").replace(/[^A-Za-z0-9\-\']/g, '').toLowerCase();

			setAdUrl(pagenewUrl);
			window.scrollTo(1, 1)
		}
	}
	const emailformCaptchaChange = (value) => {
		setemailform((prev) => ({ ...prev, captchaValue: value }));
	};
	const SubmitFormfriend = async (e) => {
		e.preventDefault();
		const isValid = emailFormvalidate();
		if (!isValid) return;
		setspinloader(1);
		let res = await sharewithfriendAction({
			...emailform, adid: id,
			url: `https://bondi-front.lyonsdemo.in${adUrl}`
		});

		if (res.success) {
			toast.success(res.msg);
			setTimeout(() => {
				window.location.reload()
			}, 1200)


		} else {
			toast.error(res.msg);
		}
		setspinloader(0);
		setTimeout(() => {
			window.location.href = `${config.baseUrl}`
		}, 3000);


	};

	// replyform
	const toggleReplyform = () => {
		setreplyto(1)
		if (adData.parent_cat == "JOBS") {
			setresume(1)
		}
		else {
			setresume(0)
		}
		setsetreplyForm((prev) => ({
			...prev,
			member_id: adData.member_id,
		}));
	}
	const inputHandlerreply = (e) => {
		const { name, value } = e.target;
		setsetreplyForm((prev) => ({
			...prev,
			[name]: value,


		}));
	};
	const inputfileHandler = (e) => {
		e.preventDefault()
		const files = Array.from(e.target.files);
		setsetreplyForm((old) => {
			return { ...old, ['images']: files }
		})
	};
	const replytoformCaptchaChange = (value) => {
		setsetreplyForm((prev) => ({ ...prev, captchaValue: value }));
	};
	function validateReplyform() {
		let nameError = "";
		let emailError = "";
		let msgError = "";
		let captchaValueError = "";
		let resumeError = "";
		const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

		if (replyform.name === '') nameError = "Name is required.";

		if (replyform.email === '') {
			emailError = "Email is required.";
		} else if (!emailRegex.test(replyform.email)) {
			emailError = "Please enter a valid email address.";
		}

		if (replyform.msg === '') msgError = "Message is required.";


		if (resume === 1 && Object.keys(replyform.images).length === 0) {
			resumeError = "Resume is required.";
		}

		if (replyform.captchaValue === '') captchaValueError = "Captcha is required.";

		if (nameError || emailError || msgError || captchaValueError || resumeError) {
			setvalidationError({
				nameError, emailError, msgError, captchaValueError, resumeError
			});
			return false;
		} else {
			setvalidationError({
				nameError, emailError, msgError, captchaValueError, resumeError
			});
			return true;
		}
	}
	const replyToclassified = async (e, adData) => {
		e.preventDefault();
		const isValid = validateReplyform();
		if (!isValid) return;
		else {
			let res = await replyToclassifiedAction({ ...replyform, member_id: adData.member_id })
			if (res.success) {
				toast.success(res.msg)
				setTimeout(() => {
					window.location.reload()
				}, 1200)

			} else {
				toast.error(res.msg)
			}
		}
	}
	const getDomainContentApi = async (domain) => {
		try {
			// Use static domain data instead of API call
			const domainData = getDomainData(domain);
			if (domainData) {
				// Only store domain_id in cookie, not the full data
				Cookies.set('domain_id', domain.toString());
				setTimeout(() => {
					window.location.href = `${config.baseUrl}ad/${id}/${any}`;
				}, 1000);
			}
		} catch (error) {
			console.error('Error loading domain content:', error);
		}
	};

	// load top banner for personals when verified
	useEffect(() => {
		const loadTopBanner = async () => {
			try {
				if (parseInt(adData.parent_cat_id) === parseInt(config.cat_per) && ageVerified) {
					const b = await getHozBannerForCategoryAction({ ad_cat: parseInt(adData.parent_cat_id) });
					setTopBanner(b?.data || null);
				} else {
					setTopBanner(null);
				}
			} catch (e) {
				setTopBanner(null);
			}
		};
		if (adData && adData.parent_cat_id !== undefined) loadTopBanner();
	}, [adData, ageVerified]);

	const handleHozBannerClick = async (banner) => {
		try {
			if (!banner) return;
			await logBannerClickAction({ ad_id: banner.ad_id, type: 2, metrocity: Domainid?.domain_id || 0 });
		} catch (e) { /* noop */ }
	};
	const responseFacebook = async (response) => {
		let res = await memberloginwithfacebookAction(response)
		if (res.success) {
			toast.success(res.msg)
			Cookies.set('loginSuccessMember', JSON.stringify(res.data));
			setTimeout(() => {
				window.location.href = `${config.baseUrl}`;
			}, 1200);
		}
		else {
			toast.error(res.msg)
		}
	}
	return (
		<>
			<Header />
			
			<Helmet>
				<title>{adData.title +' - '+ adData.cat_name +' - '+ adData.parent_cat +' - '+ adData.suburb}</title>
				<meta name="description" content />
				<meta name="keywords" content />
				
				
			</Helmet>
			
			<Toaster />
			<div className="product-single">
				<div className="container">
					{spinloader == 0 ?
						<div className="baner-small">
							<Link className="home-icon" to={config.baseUrl}><i className="fa-solid fa-house-chimney"></i></Link>
							<span>/</span>
							<Link to="#">{adData.parent_cat}</Link>
							<span>/</span>
							<Link to={catUrl} onClick={() => handleCatUrl(adData)} onMouseOver={() => getCatUrl(adData)} onMouseOut={() => setCatUrl('')}>{adData.cat_name} </Link>
							<span>/</span>
							<Link to="#">{adData.title}</Link>
						</div>
						: ''}
				</div>
			</div>

			<div className="add-section">
				<div className="container">
					<div className="row">
						<div className="col-lg-3">
							<Leftnav />
						</div>
                        <div className="col-lg-6">
                            <div className="plan-section">
                                {topBanner ? (
                                    <div className="banner-post mt-3">
                                        <a
											href={topBanner.ad_url || '#'}
											onClick={() => handleHozBannerClick(topBanner)}
											target={topBanner.ad_url ? '_blank' : undefined}
											rel={topBanner.ad_url ? 'noopener noreferrer' : undefined}
											title={topBanner.ad_title || 'banner'}
											style={{ cursor: 'pointer', display: 'block' }}
										>
                                            <img src={config.bannersUrl + topBanner.ad_file} alt={topBanner.ad_title || 'banner'} />
                                        </a>
                                    </div>
                                ) : null}
                                {parseInt(adData.parent_cat_id) == parseInt(config.cat_per) && !ageVerified ? (
                                    <div className="buy-end-sell">
                                        <div className="generalMessage">
                                            <h3 className="text-center">Warning Explicit Material!</h3>
                                            <p>
                                                This is an adult oriented section of Bondi Classifieds which may contain images, language and other explicit material not suitable for children and teens under 18.<br /><br />
                                                By entering this site, you are certifying that you are of legal adult age and are therefore liable for any ramifications, legal or otherwise, that may arise from your viewing and reading the contents herein.
                                            </p>
                                            <p>
                                                The act of entering this site indicates agreement on your part with all of the above statements.
                                            </p>
                                            <div className="text-center">
                                                <button type="button" onClick={handleOver18}>I'M OVER 18 LET ME IN</button>
                                                <button type="button" onClick={handleUnder18}>NO I'M NOT OVER 18</button>
                                            </div>
                                        </div>
                                    </div>
                                ) : spinloader === 0 ? (
									<>

										<div className="arrow-btn">
											<div className="back-btn" >
												<a to="#" onClick={() => navigate(-1)} style={{ background: headerButtonColor }}><span><i className="fa-solid fa-angles-left" ></i></span>Back</a>
											</div>
                                                <div className="viewbtn">
                                                    <div className="prev-btn">
                                                        <a to="#"
                                                           onClick={handlePrev}
                                                           className={!prevAd ? 'disabled' : ''}
                                                           style={{ background: headerButtonColor, pointerEvents: !prevAd ? 'none' : 'auto', opacity: !prevAd ? .5 : 1 }}
                                                        >
                                                            <span><i className="fa-solid fa-angles-left" ></i></span>Prev
                                                        </a>
                                                    </div>
                                                    <div className="next-btn">
                                                        <a to="#"
                                                           onClick={handleNext}
                                                           className={!nextAd ? 'disabled' : ''}
                                                           style={{ background: headerButtonColor, pointerEvents: !nextAd ? 'none' : 'auto', opacity: !nextAd ? .5 : 1 }}
                                                        >
                                                            Next<span><i className="fa-solid fa-angles-right"></i></span>
                                                        </a>
                                                    </div>
                                                </div>
										</div>
										{showreport === 0 ? (
											<>
												<div className="heading-super" onClick={(e) => toggleReplyform(adData)} style={{ background: headerMenuColor }}>
													<h6>{adData.title}</h6>
												</div>

												<div>
													{/* <div className="item-purchased mb-3 mt-3 ad-description" dangerouslySetInnerHTML={{ __html: adData?.discription }}></div> */}
													{adImges.length > 0 ? (
														<><div className="blogs" id="lightgallery">
															{adImges.map((row, index) => (
																<a 
																	key={index} 
																	href={`${config.adImgUrl}${row.addImg}`} 
																	data-src={`${config.adImgUrl}${row.addImg}`}
																	data-thumb={`${config.adImgUrl}small_${row.addImg}`}
																	data-sub-html={`<h4>${adData.title}</h4>`}
																	className="gallery-section"
																>
																	<img alt={adData.title} src={`${config.adImgUrl}small_${row.addImg}`} />
																</a>
															))}
														</div>
														</>
													) : (
														''
													)}


													{parseInt(adData.parent_cat_id) === parseInt(config.cat_per) && (
														<>
															<div className="location">
																<p><span><i className="fa-solid fa-user"></i></span> Age: {adData.age}</p>
															</div>
															<div className="location">
																<p><span><i className="fa-solid fa-venus-double"></i></span> Gender: {adData.sex === 0 ? 'Male' : 'Female'}</p>
															</div>
														</>
													)}</div>
												<div className="location">
													<p>
														<Link to="#">
															<span><i className="fa-solid fa-location-dot"></i></span>
															{adData.suburb} ({adData.area})
														</Link>
													</p>
												</div>

												{parseInt(adData.parent_cat_id) === parseInt(config.cat_real) && (
													<>
														<div className="location">
															<p><span><i className="fa-regular fa-building"></i></span> Property Type: {adData.property_type}</p>
														</div>
														<div className="location">
															<p><span><i className="fa-solid fa-street-view"></i></span> Street No: {adData.street_number}</p>
														</div>
														<div className="location">
															<p><span><i className="fa-solid fa-street-view"></i></span> Street Name: {adData.street_name}</p>
														</div>
														<div className="location">
															<p><span><i className="fa-solid fa-dollar-sign"></i></span> ${adData.sell_price}</p>
														</div>
														<div className="location">
															<p><span><i className="fa-solid fa-bed"></i></span> Bedrooms: {adData.bed_rooms}</p>
														</div>
														<div className="location">
															<p><span><i className="fa-regular fa-building"></i></span> Unit / Flat: {adData.unit_flat}</p>
														</div>
													</>
												)}

												{parseInt(adData.parent_cat_id) === parseInt(config.cat_buy) && (
													<div className="location">
														<p><span><i className="fa-solid fa-dollar-sign"></i></span> ${adData.sell_price}</p>
													</div>
												)}

												{parseInt(adData.parent_cat_id) === parseInt(config.cat_whats) && (
													<>
														<div className="location">
															<p><span><i className="fa-solid fa-calendar-days"></i></span> Date: {adData.formatted_whatson_date}</p>
														</div>
														<div className="location">
															<p><span><i className="fa-regular fa-clock"></i></span> Time: {adData.time_whatson}</p>
														</div>
														<div className="location">
															<p><span><i className="fa-solid fa-dollar-sign"></i></span> ${adData.sell_price}</p>
														</div>
													</>
												)}

												{parseInt(adData.parent_cat_id) === parseInt(config.cat_jobs) && (
													<div className="location">
														<p><span><i className="fa-solid fa-briefcase"></i></span> Work type: {adData.job_work_type}</p>
													</div>
												)}

												{parseInt(adData.parent_cat_id) === parseInt(config.cat_business) && (
													<>
														<div className="location">
															<p><span><i className="fa-solid fa-user-tag"></i></span> ABN: {adData.abn}</p>
														</div>
														<div className="location">
															<p><span><i className="fa-regular fa-circle-check"></i></span> Accreditation: {adData.accreditation}</p>
														</div>
													</>
												)}


											</>

										)
											: ''}


										{showreport === 0 ?
											<>
												<div className="heading-super" onClick={replyto == 1 ? (() => setreplyto(0)) : toggleReplyform} style={{ background: headerMenuColor, cursor: 'pointer' }}>
									<h6>Reply to this Classified</h6>
												</div>
												{
													replyto === 1 ?
														(
															<>
																<form action='' method='post'>
																	<div className="bondiclassified-fromsection">
																		<div className="catagoryfrom">
																			<div className="row">
																				<div className="col-md-12 col-sm-12">
																					<div className="form-group">
																						<label htmlFor="name">Name <span className='text-danger'>*</span></label>
																						<input type='text' className='form-control' name="name" id="name" onChange={inputHandlerreply} value={replyform.name} />
																						<span className="text-danger">{validationError.nameError}</span>
																					</div>
																				</div>
																				<div className="col-md-12 col-sm-12">
																					<div className="form-group">
																						<label htmlFor="email">Email <span className='text-danger'>*</span></label>
																						<input type='text' className='form-control' name='email' id='email' onChange={inputHandlerreply} value={replyform.email} />
																						<span className="text-danger">{validationError.emailError}</span>
																					</div>
																				</div>
																				<div className="col-md-12 col-sm-12">
																					<div className="form-group">
																						<label htmlFor="msg">Message <span className='text-danger'>*</span></label>
																						<textarea className="form-control" name="msg" rows='5' id='msg' onChange={inputHandlerreply} value={replyform.msg}></textarea>
																						<span className="text-danger">{validationError.msgError}</span>
																					</div>
																				</div>
																				{resume === 1 ?
																					<div className="col-md-12 col-sm-12">
																						<div className="form-group">
																							<label htmlFor="msg">Attach Resume <span className='text-danger'>*</span></label>
																							<input type='file' className="form-control-file" name="resume" rows='5' id='resume' onChange={inputfileHandler} required />
																							<span className="text-danger">{validationError.resumeError}</span>
																						</div>
																					</div> : ""}
																				<div className="col-md-12 col-sm-12">
																					<div className="form-group">
																						<ReCAPTCHA
																							ref={recaptchaRef}
																							sitekey={config.site_key}
																							onChange={replytoformCaptchaChange}

																						/>
																						<span className="text-danger">{validationError.captchaValueError}</span>
																					</div>
																				</div>
																				<div className="col-md-12 mt-3 pdb-20">
																					{spinloader === 0 ? (
																						<button type="button" onClick={(e) => replyToclassified(e, adData)} className="btn btn-primary login-btn" style={{ background: headerButtonColor }}>
																							Send
																						</button>
																					) : (
																						<button disabled className="btn btn-primary login-btn" style={{ background: headerButtonColor }}>
																							Sending.. <i className="fa fa-spinner fa-spin validat"></i>
																						</button>
																					)}
																				</div>
																			</div>
																		</div>
																	</div>
																</form>
															</>
														)
														: ""}

												<div className="icon-socialmedia user-icon" >
													<div className="heart" >
														{getfavAds.includes(adData.id) ?
										(<a
																className="fevcls"
																id='heart'
																title=""
											style={{ cursor: 'pointer' }}
																onClick={() => handleFavorite(adData.id)}
															>
																<i className="fa fa-heart" aria-hidden="true"></i>
															</a>)
															:
										(<a
																className="fevcls"
																title=''

																id='heart'
											style={{ cursor: 'pointer' }}
																onClick={() => handleFavorite(adData.id)}
															>
																<i
																	className="fa-regular fa-heart" aria-hidden="true"	></i>
															</a>
															)
														}
													</div>

													<div className="facebook">
														<Link to="#"><i className="fa-brands fa-facebook-f"></i>
															{/* <FacebookLogin
																cssClass="btnFacebook"
																appId="986705326547259"
																autoLoad={false}
																fields="name,email,picture"
																callback={responseFacebook}
																icon="fa fa-facebook"
																textButton="&nbsp;&nbsp;Login with Facebook"

															/> */}
															</Link>
													</div>
													<div className="facebook twiter">
														<Link to="#"><i className="fa-solid fa-x"></i></Link>
													</div>
													<div className="facebook linkdin">
														<Link to="#"><i className="fa-brands fa-linkedin-in"></i></Link>
													</div>
													<div className="facebook piterest">
														<Link to="#"><i className="fa-brands fa-pinterest-p"></i></Link>
													</div>
													<div className="facebook email">
														<Link to="#"><i className="fa-solid fa-envelope"></i></Link>
													</div>
													<div className="facebook text-icon">
														<Link to="#"><i className="fa-solid fa-t"></i></Link>
													</div>


													<div className="email-btn">
														<a href="javascript:;" onClick={() => ShowFriendFrom(adData)} style={{ background: headerButtonColor }}>Email A Friend</a>
													</div>
													<div className="email-btn">
														<a href="javascript:;" onClick={() => ShowReportFrom(adData)} style={{ background: headerButtonColor }}>Report</a>
													</div>

												</div>
											</>
											: ""}



										{showreport === 1 ?
											(<div className="classification-section" style={{ marginTop: "20px" }}>
												<h2 className="page-heading" style={{ background: headerMenuColor }}>Report This Post</h2>
												<h2 className="page-heading" style={{ background: headerMenuColor }}>{adData.title}</h2>
												<form action='' method='post'>
													<div className="bondiclassified-fromsection">
														<div className="catagoryfrom">
															<div className="row">

																<div className="col-md-12 col-sm-12">
																	<div className="form-group">
																		<label htmlFor="name">Name <span className='text-danger'>*</span></label>
																		<input type='text' className='form-control' name='name' id='name' onChange={inputHandler} value={form.name} />
																		<span className="text-danger">{validationError.nameError}</span>
																	</div>
																</div>
																<div className="col-md-12 col-sm-12">
																	<div className="form-group">
																		<label htmlFor="email">Email <span className='text-danger'>*</span></label>
																		<input type='text' className='form-control' name='email' id='email' onChange={inputHandler} value={form.email} />
																		<span className="text-danger">{validationError.emailError}</span>
																	</div>
																</div>
																<div className="col-md-12 col-sm-12">
																	<div className="form-group">
																		<label htmlFor="msg">Message <span className='text-danger'>*</span></label>
																		<textarea className="form-control" name="msg" rows='5' id='msg' onChange={inputHandler} value={form.msg}></textarea>
																		<span className="text-danger">{validationError.msgError}</span>
																	</div>
																</div>
																<div className="col-md-12 col-sm-12">
																	<div className="form-group">
																		<ReCAPTCHA
																			ref={recaptchaRef}
																			sitekey={config.site_key}
																			onChange={onCaptchaChange}
																		/>
																		<span className="text-danger">{validationError.captchaValueError}</span>
																	</div>
																</div>
																<div className="col-md-12 mt-3 pdb-20">
																	{spinloader === 0 ? (
																		<button type="button" onClick={SubmitForm} className="btn btn-primary login-btn" style={{ background: headerButtonColor }}>
																			Send
																		</button>
																	) : (
																		<button disabled className="btn btn-primary login-btn" style={{ background: headerButtonColor }}>
																			Sending.. <i className="fa fa-spinner fa-spin validat"></i>
																		</button>
																	)}
																</div>
															</div>
														</div>
													</div>
												</form>
											</div>
											) : ''}

										{showreport === 2 ? (
											<>
												<div className="classification-section">
													<h2 className="page-heading" style={{ background: headerMenuColor }}> Email To Friend </h2>
													<form action='' method='post'>
														<div className="bondiclassified-fromsection">
															<div className="catagoryfrom">

																<div className="row">
																	<div className="col-md-12 col-sm-12">
																		<div className="form-group">
																			<label htmlFor="name">Name <span className='text-danger'>*</span></label>
																			<input type='text' className='form-control' name="name" id="name" onChange={emailinputHandler} value={emailform.name} />
																			<span className="text-danger">{validationError.nameError}</span>
																		</div>
																	</div>

																	<div className="col-md-12 col-sm-12">
																		<div className="form-group">
																			<label htmlFor="email">Email <span className='text-danger'>*</span></label>
																			<input type='text' className='form-control' name='email' id='email' onChange={emailinputHandler} value={emailform.email} />
																			<span className="text-danger">{validationError.emailError}</span>
																		</div>
																	</div>

																	<div className="col-md-12 col-sm-12">
																		<div className="form-group">
																			<label htmlFor="email">Friend Email <span className='text-danger'>*</span></label>
																			<input type='text' className='form-control' name='femail' id='fname' onChange={emailinputHandler} value={emailform.femail} />
																			<span className="text-danger">{validationError.femailError}</span>
																		</div>
																	</div>


																	<div className="col-md-12 col-sm-12">
																		<div className="form-group">
																			<label htmlFor="msg">Message <span className='text-danger'>*</span></label>
																			<textarea className="form-control" name="msg" rows='5' id='msg' onChange={emailinputHandler} value={emailform.msg}></textarea>
																			<span className="text-danger">{validationError.msgError}</span>
																		</div>
																	</div>
																	<div className="col-md-12 col-sm-12">
																		<div className="form-group">
																			<ReCAPTCHA
																				ref={recaptchaRef}
																				sitekey={config.site_key}
																				onChange={emailformCaptchaChange}
																			/>
																			<span className="text-danger">{validationError.captchaValueError}</span>
																		</div>
																	</div>
																	<div className="col-md-12 mt-3 pdb-20">
																		{spinloader === 0 ? (
																			<button
																				type="button"
																				onClick={SubmitFormfriend}
																				className="btn btn-primary login-btn"
																				style={{ background: headerMenuColor }}
																			>
																				Send
																			</button>
																		) : (
																			<button disabled className="btn btn-primary login-btn" style={{ background: headerMenuColor }}>
																				Sending.. <i className="fa fa-spinner fa-spin validat"></i>
																			</button>
																		)}
																	</div>
																</div>
															</div>
														</div>
													</form>
												</div>

											</>) : ""}


									</>
								) : (
									<div className="loaderDiv">
										<img className="loaderImg" src={config.baseUrl + "img/loader.gif"} height={50} width={50} />
									</div>
								)}

				{/* Ad Description Section */}
				{adData?.discription && !(parseInt(adData.parent_cat_id) == parseInt(config.cat_per) && !ageVerified) && (
									<div className="ad-description-section" style={{ marginTop: "20px", marginBottom: "20px" }}>
										<div style={{ background: headerMenuColor }} className="heading-super">
											<h6>DESCRIPTION</h6>
										</div>
										<div className="ad-description-content" style={{ 
											padding: "15px", 
											background: "#fff", 
											borderRadius: "5px",
											lineHeight: "1.6",
											fontSize: "14px"
										}}>
											<div dangerouslySetInnerHTML={{ __html: adData.discription }}></div>
										</div>
									</div>
								)}
								






								{relatedAds.length > 0 && (
									<>
										<div style={{ marginTop: "20px", background: headerMenuColor }} className="heading-super">
											<h6>OTHER RELATED ADS</h6>
										</div>
										{relatedAds.map((row, index) => (
											<div key={index} className={index % 2 === 0 ? 'section-listing' : 'section-listing section-listing-new'}>
												<div className="main-item">
													<div className="fast-block">
														{row.addImg && row.addImg !== '' ? (
															<img src={config.apiUrl + row.addImg} alt={row.title} />
														) : (
															<img src={config.baseUrl + "img/noImage.png"} alt={row.title} />
														)}
													</div>
													<div className="second-block">
														<Link className="fordhead" to={adUrl} onClick={() => handleAdUrl(row)} onMouseOver={() => getAdUrl(row)} onMouseOut={() => setAdUrl('')}>
															{row.title}
														</Link>
														<div className="price">
															<p><strong>${row.sell_price}</strong></p>
														</div>
														<p><span><i className="fa-solid fa-location-dot"></i></span> {row.suburb} ({row.area})</p>
													</div>
													{getfavAds.includes(row.id) ?
														(<a
															className="fevcls"
															title=""
															onClick={() => handleFavorite(row.id)}
														>
															<i className="fa fa-heart" aria-hidden="true"></i>
														</a>)
														:
														(<a
															className="fevcls"
															title=''
															onClick={() => handleFavorite(row.id)}
														>
															<i
																className="fa-regular fa-heart" aria-hidden="true"	></i>
														</a>
														)
													}
												</div>
											</div>
										))}
									</>
								)}

							</div>

						</div>
						<div className="col-lg-3">
							<Rightnav />
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</>
	)
}

export default Addetails;
